<mat-toolbar>
  <button mat-icon-button matTooltip="Volver al dashboard" routerLink="/contenedores">
    <mat-icon color="primary">arrow_back</mat-icon>
  </button>
  Mantenimientos
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    @if (canAltaMantenimiento()) {
      <button mat-menu-item (click)="newMantenimiento()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir mantenimiento</button>
    }
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <div>
      <mat-form-field class='searchInput searchMobile50'>
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="active" (selectionChange)="getMantenimientos()">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="start">Pendiente inicio</mat-option>
          <mat-option value="process">En proceso</mat-option>
          <mat-option value="finish">Finalizado</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class='searchInput searchMobile50'>
        <mat-label>Tipo</mat-label>
        <mat-select [(value)]="tipo" (selectionChange)="getMantenimientos()">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="paint">Pintado</mat-option>
          <mat-option value="fix">Reparación</mat-option>
          <mat-option value="incidence">Incidencia</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          @if (canManageContenedores()) {
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon matTooltip="Acciones">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editarMantenimiento(element.idMantenimiento)">
                <mat-icon color="primary">create</mat-icon>
                <span>Ver/Modificar</span>
              </button>
              <button mat-menu-item (click)="deleteMantenimiento(element.idMantenimiento)">
                <mat-icon color="primary">delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Matricula </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.matricula}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaAlta">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Fecha alta </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.fechaAlta}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaAccion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Fecha acción</th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.fechaAccion}} </td>
      </ng-container>
      <ng-container matColumnDef="coste">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Coste </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.coste}} </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Tipo </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          <!--<mat-icon *ngIf="element.tipo === 'start'" class="grey" matTooltip="Pendiente inicio">pending</mat-icon>-->
          @if (element.tipo === 'paint') {
            <mat-icon class="grey" matTooltip="Pintado">imagesearch_roller</mat-icon>
          }
          @if (element.tipo === 'fix') {
            <mat-icon class="grey" matTooltip="Reparación">build</mat-icon>
          }
          @if (element.tipo === 'incidence') {
            <mat-icon class="grey" matTooltip="Incidencia">warning</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Estado </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          @if (element.estado === 'pending') {
            <mat-icon class='red' matTooltip="Pendiente inicio">fiber_manual_record</mat-icon>
          }
          @if (element.estado === 'process') {
            <mat-icon class='orange' matTooltip="En proceso">fiber_manual_record</mat-icon>
          }
          @if (element.estado === 'finish') {
            <mat-icon class='green' matTooltip="Finalizado">fiber_manual_record</mat-icon>
          }
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="6">No existen mantenimientos...
          @if (canAltaMantenimiento()) {
            <br> <button mat-stroked-button (click)="newMantenimiento()">Añadir mantenimiento</button>
          }
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
